export const StatusBadgeColumn = ({ statusName, onClick }) => {
    const renderBadge = () => {
        switch (statusName) {
            case "Active":
            case "Competition":
            case "IN":
            case "Merit":
                return <span onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }} className="badge text-uppercase bg-success text-white">{statusName}</span>
            case "InActive":
            case "Home Leave":
            case "OUT":
            case "In-Active":
            case "Demerit":
                return <span onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }} className="badge text-uppercase bg-danger text-white">{statusName}</span>
            default:
                return <span onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }} className="badge text-uppercase bg-secondary text-white">{statusName}</span>
        }
    };

    return renderBadge();
};